global.__litium = global.__litium || {};
window.__litium.themeName = 'oh-poppy';
global.__litium.themeName = 'oh-poppy';

require('./app.js');
